import FeaturedProducts from "./FeaturedProducts";

import HomeImage from "../images/img-home.jpg";
import NavBar from "./NavBar";
import DetailsHome from "./DetailsHome";
import { useDispatch, useSelector } from "react-redux";
import { afterFirstTime } from "../Redux/firstTimeSlice";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "./Home.css";

function Home() {
  const toastId = React.useRef(null);

  const notify = () =>
    (toastId.current = toast.info("Restoring Database", { autoClose: false }));

  const dismiss = () => toast.dismiss(toastId.current);

  const dispatch = useDispatch();
  const firstTime = useSelector((state) => state.firstTime);

  const [show, setShow] = useState(true);

  const handleClose = () => {
    dispatch(afterFirstTime());
  };

  const handleReset = async () => {
    notify();
    const response = await axios.get(
      `${process.env.REACT_APP_URL_BACK}/admin/reset`
    );
    dismiss();
    if (response.data === "OK") {
      toast.success("Database restored successfully");
      setTimeout(() => {
        window.location.reload(false);
      }, 3000);
    }
  };

  return (
    <div className="position-relative ">
      <NavBar />
      <img
        className="bkg w-100 "
        src={HomeImage}
        alt="table with tea and coffee"
      ></img>

      <FeaturedProducts />
      <div className="container">
        <div className="row">
          <div className="col-8 col-lg-10"></div>
        </div>
      </div>

      <DetailsHome />

      {firstTime === true && (
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Welcome to Hackoffee!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            For a better experience we suggest to reset the database.
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                handleClose();
                handleReset();
              }}
            >
              Reset Database
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <ToastContainer
        position="top-center"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default Home;
